import { createContext, useState, useEffect, useCallback } from "react";
import profileService from "../services/profileService";

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  // Get initial state from localStorage for quick render
  const getInitialState = () => {
    const saved = localStorage.getItem('sidebarCollapsed');
    // If saved is 'true', sidebar should be collapsed (isSidebar = false)
    return saved === 'true' ? false : true;
  };

  const [isSidebar, setIsSidebar] = useState(getInitialState);

  // Load sidebar preference from backend on mount
  useEffect(() => {
    const loadSidebarPreference = async () => {
      const token = localStorage.getItem('authToken');
      if (token) {
        try {
          const preferences = await profileService.getPreferences();
          if (preferences?.sidebarCollapsed !== undefined) {
            const collapsed = preferences.sidebarCollapsed;
            localStorage.setItem('sidebarCollapsed', String(collapsed));
            // If collapsed is true, sidebar should be hidden (isSidebar = false)
            setIsSidebar(!collapsed);
          }
        } catch (error) {
          console.debug('Could not load sidebar preference:', error);
        }
      }
    };
    loadSidebarPreference();
  }, []);

  // Function to reload sidebar preference from backend (called after login)
  const reloadSidebarPreference = useCallback(async () => {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        const preferences = await profileService.getPreferences();
        if (preferences?.sidebarCollapsed !== undefined) {
          const collapsed = preferences.sidebarCollapsed;
          localStorage.setItem('sidebarCollapsed', String(collapsed));
          setIsSidebar(!collapsed);
        }
      } catch (error) {
        console.debug('Could not load sidebar preference:', error);
      }
    }
  }, []);

  // Apply preference from login callback
  const applyPreference = useCallback((preferences) => {
    if (preferences?.sidebarCollapsed !== undefined) {
      const collapsed = preferences.sidebarCollapsed;
      localStorage.setItem('sidebarCollapsed', String(collapsed));
      setIsSidebar(!collapsed);
    }
  }, []);

  return (
    <SidebarContext.Provider value={{ isSidebar, setIsSidebar, reloadSidebarPreference, applyPreference }}>
      {children}
    </SidebarContext.Provider>
  );
};